<div class="company-trial-kit">
  <form [formGroup]="form">
    <div class="form-group">
      <label for="firstName" translate>company.trial-kit.form.first-name.label</label>
      <div class="vox-input-group vox-input-group_dense" [ngClass]="{
          'vox-input-group_invalid': validField('firstName')
        }">
        <input class="vox-text-field" type="text" id="firstName" formControlName="firstName" placeholder="{{'company.trial-kit.form.first-name.placeholder' | translate}}" /><i
          class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
          class="vox-input-group__error-message" translate>company.trial-kit.form.first-name.error</span>
      </div>
    </div>
    <div class="form-group">
      <label for="lastName" translate>company.trial-kit.form.last-name.label</label>
      <div class="vox-input-group vox-input-group_dense" [ngClass]="{
          'vox-input-group_invalid': validField('lastName')
        }">
        <input class="vox-text-field" type="text" id="lastName" formControlName="lastName" placeholder="{{'company.trial-kit.form.last-name.placeholder' | translate}}" /><i
          class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
          class="vox-input-group__error-message" translate>company.trial-kit.form.last-name.error</span>
      </div>
    </div>
    <div class="form-group">
      <label for="email" translate>company.trial-kit.form.email.label</label>
      <div class="vox-input-group vox-input-group_dense" [ngClass]="{
          'vox-input-group_invalid': validField('email')
        }">
        <input class="vox-text-field" type="text" id="email" formControlName="email" placeholder="{{'company.trial-kit.form.email.placeholder' | translate}}" /><i
          class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
          class="vox-input-group__error-message">{{ getErrorEmail() | translate }}</span>
      </div>
    </div>
    <div class="form-group">
      <label for="prefix" translate>company.trial-kit.form.trial-kit.label</label>
      <div ngbDropdown class="vox-dropdown-input" placement="bottom">
        <button
          id="trial-kit-dropdown"
          ngbDropdownToggle
          >
          {{selectedKit.name | translate}}
        </button>
        <div ngbDropdownMenu aria-labelledby="trial-kit-dropdown">
          <button ngbDropdownItem
          type="button"
          *ngFor="let kit of trialKits; let idx = index"
          (click)="onSelectKit(kit)"
          translate>
          {{kit.name}}
        </button>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="companyName" translate>company.trial-kit.form.company-name.label</label>
      <div class="vox-input-group vox-input-group_dense" [ngClass]="{
          'vox-input-group_invalid': validField('companyName')
        }">
        <input class="vox-text-field" type="text" id="companyName" formControlName="companyName" placeholder="{{'company.trial-kit.form.company-name.placeholder' | translate}}" /><i
          class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
          class="vox-input-group__error-message" translate>company.trial-kit.form.company-name.error</span>
      </div>
    </div>
    <div class="form-group">
      <label for="address" translate>company.trial-kit.form.address.label</label>
      <div class="vox-input-group vox-input-group_dense"
      [ngClass]="{ 'vox-input-group_invalid': validField('address') }">
          <vox-address-search formControlName="address"
          [googleKey]="googleKey"
          placeholder="{{'company.trial-kit.form.address.placeholder' | translate}}">
          </vox-address-search>
      <span class="vox-input-group__error-message" translate>company.trial-kit.form.address.error</span>
      </div>
    </div>
    <div class="submit-container">
      <button class="vox-btn vox-btn-primary" type="submit" (click)="onSubmit()" [disabled]="form.invalid" [ladda]="loading" data-spinner-color="grey" data-style="zoom-in"><span translate>company.trial-kit.form.submit</span></button>
    </div>
  </form>
</div>
